Namespace 'Profile.UserProfile'

class Profile.UserProfile.UserProfileMergeExclusion extends Backbone.Model
  defaults:
    first_profile_id: ''
    second_profile_id: ''

class Profile.UserProfile.UserProfileMergeExclusionCollection extends Backbone.Collection
  model: Profile.UserProfile.UserProfileMergeExclusion
  url: '/profiles/api/user_profile_merge_exclusions'

  save: (options) =>
    options ||= {}
    options.url = @url
    Backbone.sync('create', @, options)
